import React from 'react';
import classnames from 'classnames';

import Dropdown from 'ub/components/dropdown/dropdown';
import { LabelFlair } from 'comp/flairs';
import SOURCES from 'ub/ui/asset-library/asset-sources';
import { assetSourcePropType, assetTypePropType, sortByPropType } from './prop-types';
import { TYPES } from 'ub/ui/asset-library/asset-types';

import styles from './toolbar.scss';

function SortOption({ isAscending, isSelected, label, onClick, value }) {
  const className = classnames(styles.sortOption, {
    [styles.isAscending]: isAscending,
    [styles.isSelected]: isSelected,
  });

  return (
    <div className={className} onClick={() => onClick(value)}>
      {label}
      {isSelected && <div className={styles.ascDsc} />}
    </div>
  );
}

SortOption.propTypes = {
  isAscending: React.PropTypes.bool.isRequired,
  isSelected: React.PropTypes.bool.isRequired,
  label: React.PropTypes.string.isRequired,
  onClick: React.PropTypes.func.isRequired,
  value: React.PropTypes.string.isRequired,
};

export default class Toolbar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleChangeSource = this.handleChangeSource.bind(this);
    this.handleChangeSort = this.handleChangeSort.bind(this);
    this.handleStartDelete = this.handleStartDelete.bind(this);
    this.handleFocusSearch = this.handleFocusSearch.bind(this);
  }

  handleChangeType(selectedType) {
    this.props.dispatch({ type: 'changeType', assetType: selectedType });
  }

  handleChangeSearch(event) {
    this.props.dispatch({ type: 'changeSearch', value: event.target.value });
  }

  handleChangeSource(source) {
    this.props.dispatch({ type: 'changeSource', source });
  }

  handleChangeSort(sortBy) {
    this.props.dispatch({ type: 'changeSort', sortBy });
  }

  handleStartDelete() {
    if (this.props.allowDelete) {
      this.props.dispatch({ type: 'startDelete' });
    }
  }

  handleFocusSearch(event) {
    window.editor.keyController.requestFocus(event.target);
  }

  render() {
    const {
      allowDelete,
      searchTerm,
      selectedSource,
      selectedType,
      sortAscending,
      sortBy,
      sortVisible,
      sourceDropdownVisible,
      typeTotals,
      visibleTypes,
    } = this.props;

    return (
      <div className={styles.toolbar}>
        <div className={styles.row}>
          {sourceDropdownVisible && (
            <Dropdown
              label={SOURCES[selectedSource].label}
              changeHandler={this.handleChangeSource}
              className={styles.sourceDropdown}
              options={Object.keys(SOURCES)
                .filter(name => SOURCES[name].enabled)
                .map(name => ({
                  value: name,
                  label: (
                    <div>
                      {SOURCES[name].label}
                      {SOURCES[name].isNew && <LabelFlair type="new">New!</LabelFlair>}
                    </div>
                  ),
                }))}
            />
          )}

          <div className={styles.types}>
            {visibleTypes.map(type => (
              <button
                className={classnames(styles.type, { [styles.isSelected]: selectedType === type })}
                onClick={() => this.handleChangeType(type)}
                type="button"
                key={type}
              >
                {TYPES[type].tabText} ({typeTotals[type]})
              </button>
            ))}
          </div>
        </div>

        <div className={styles.row}>
          <button
            className={classnames(styles.deleteButton, 'svg-ico-delete', {
              [styles.isDisabled]: !allowDelete,
            })}
            type="button"
            onClick={this.handleStartDelete}
          />

          <div className={styles.searchWrapper}>
            <label
              className={classnames(styles.searchLabel, 'svg-ico-search')}
              htmlFor="asset-browser-search"
            />
            <input
              type="text"
              className={styles.searchInput}
              id="asset-browser-search"
              value={searchTerm}
              onChange={this.handleChangeSearch}
              onFocus={this.handleFocusSearch}
            />
          </div>

          {sortVisible && (
            <div className={styles.sortOptions}>
              <SortOption
                isAscending={sortAscending}
                isSelected={sortBy === 'date'}
                label="Created"
                onClick={this.handleChangeSort}
                value="date"
              />

              <SortOption
                isAscending={sortAscending}
                isSelected={sortBy === 'filename'}
                label="Name"
                onClick={this.handleChangeSort}
                value="filename"
              />

              <SortOption
                isAscending={sortAscending}
                isSelected={sortBy === 'filesize'}
                label="Filesize"
                onClick={this.handleChangeSort}
                value="filesize"
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

Toolbar.propTypes = {
  allowDelete: React.PropTypes.bool.isRequired,
  dispatch: React.PropTypes.func.isRequired,
  searchTerm: React.PropTypes.string.isRequired,
  selectedSource: assetSourcePropType.isRequired,
  selectedType: assetTypePropType.isRequired,
  sortAscending: React.PropTypes.bool.isRequired,
  sortBy: sortByPropType.isRequired,
  sortVisible: React.PropTypes.bool.isRequired,
  sourceDropdownVisible: React.PropTypes.bool.isRequired,
  typeTotals: React.PropTypes.object.isRequired,
  visibleTypes: React.PropTypes.arrayOf(assetTypePropType).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/asset-library/toolbar.jsx